if (!customElements.get('form-klaviyo-check')) {
    customElements.define('form-klaviyo-check',
class formKlaviyoCheck extends HTMLElement {
    constructor() {
      super();
      this.formButton = this.querySelector("form button");
      this.formEmail = this.querySelector("#custom_email_signup");
      this.listID = "UKCdaK";
      this.subscribeURL = "https://earthechofoods.com/pages/cacaobliss";

        this.formButton.addEventListener("click", (event) => {
            event.preventDefault();
            this.checkProfileEmailsInList(this.formEmail.value, this.listID);
        });
      
    }

    redirectToSubscribe() {
        window.location.href = this.subscribeURL;
    }

    checkProfileEmailsInList(email, listId) {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        
        let data = JSON.stringify({
            "listId": listId,
            "emails": [email]
        });

        let requestOptions = {
            headers: myHeaders,
            method: 'POST',
            body: data
          };
          
          fetch("https://us-central1-fluent-limiter-210701.cloudfunctions.net/CheckProfileEmailsInList", requestOptions)
          .then(response => response.json())
          .then((result) => {
                if (result.data && result.data.length > 0) {
                    const event = new CustomEvent("klaviyoChecked", {
                        detail: true
                      });
                    document.dispatchEvent(event);
                } else {
                    this.redirectToSubscribe();
                }
          })
          .catch(error => console.log('error', error));
    }

  }
);
}
